import { ConfigProvider } from '@arco-design/web-react';
import { useContext } from 'react';
var defaultCopy = {
    optional: 'Optional',
};
export var useI18nCopy = function () {
    var _a;
    var locale = useContext(ConfigProvider.ConfigContext).locale;
    var t = ((_a = locale === null || locale === void 0 ? void 0 : locale.Form) === null || _a === void 0 ? void 0 : _a.optional)
        ? locale === null || locale === void 0 ? void 0 : locale.Form
        : defaultCopy;
    return t;
};
